import { render, staticRenderFns } from "./YixiApp.vue?vue&type=template&id=f8103432&scoped=true&"
import script from "./YixiApp.vue?vue&type=script&lang=js&"
export * from "./YixiApp.vue?vue&type=script&lang=js&"
import style0 from "./YixiApp.vue?vue&type=style&index=0&id=f8103432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8103432",
  null
  
)

export default component.exports